import React from 'react';

import Modal from '../../modal/modal';

export default class AudioPlayerModal extends React.Component {

    render() {
        const { playerUrl, ...rest } = this.props;
        const contentStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        };

        if (!playerUrl) {
            return null;
        }

        return (
            <Modal show={true} {...rest} contentStyle={contentStyle}>
                <div className='modal-content-wrapper'>
                    <button className='modal-exit-btn' onClick={rest.onClose}>x</button>
                    <div className='audio-player'>
                        <iframe
                            title={playerUrl}
                            frameBorder='0'
                            src={playerUrl}
                            webkitallowfullscreen='true' mozllowfullscreen='true' allowFullScreen='true'>
                            Áudio embarcado
                        </iframe>
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/audio-modal.js